import React, { memo, useEffect, useState } from "react";
import {
  TabContext,
  TabList,
  Box,
  Tab,
  TabPanel,
} from "investira.react.components";
import { validators } from "investira.sdk";
import { useConsultaContext } from "../../../../contexts/ConsultaContext";
import { ATIVO_MERCADO, ATIVO_TIPO } from "@investirapri/financa.js/lib/enums";
import Detalhes from "./Detalhes";

const Secoes = memo((props) => {
  const { data } = props;

  const { state } = useConsultaContext();

  const [value, setValue] = useState(null);
  const [secoes, setSecoes] = useState({});

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  /**
   * Agrupa o detalhe por mercado, consolidando as posições: local e custodiante
   * @param {Object} pDetalhe - Objeto a ser agrupado
   * @returns {Object} - Objeto com os dados agrupados e ordenados
   */
  function agrupaPorMercado(pDetalhe) {
    if (validators.isEmpty(pDetalhe)) {
      return {};
    }
    const xLocal = pDetalhe?.local || {};
    const xCustodiante = pDetalhe?.custodiante || {};
    // Caso não tenha local ou custodiante, retorna array vazio
    if (validators.isEmpty(xLocal) || validators.isEmpty(xCustodiante)) {
      return {};
    }
    const xDivergencias = pDetalhe?.divergencias || {};
    const xDetalhesKeys = new Set([
      ...Object.keys(xLocal),
      ...Object.keys(xCustodiante),
    ]);
    const xMercados = {};
    for (const xDetalheKey of xDetalhesKeys) {
      const xAtivoBase = xLocal[xDetalheKey] || xCustodiante[xDetalheKey];
      if (!xAtivoBase) {
        continue;
      }
      const { operacao_taxa, quantidade, pu, financeiro, ...xAtivo } =
        xAtivoBase;

      const xMercado = xAtivoBase.mercado || "NIDX";

      // Se o mercado não existir no objeto, cria um objeto vazio para ele
      if (!xMercados[xMercado]) {
        xMercados[xMercado] = {
          detalhes: {},
          quantidade_total: 0,
          financeiro_total: 0,
        };
      }
      // Se o ativo não existir no objeto, cria um array e vazio para ele
      if (!xMercados[xMercado].detalhes[xDetalheKey]) {
        xMercados[xMercado].detalhes[xDetalheKey] = [];
      }

      const xNewAtivo = {
        ...xAtivoBase,
        local: {
          operacao_taxa: xLocal[xDetalheKey]?.operacao_taxa || null,
          quantidade: xLocal[xDetalheKey]?.quantidade || 0,
          pu: xLocal[xDetalheKey]?.pu || 0,
          financeiro: xLocal[xDetalheKey]?.financeiro || 0,
        },
        custodiante: {
          operacao_taxa: xCustodiante[xDetalheKey]?.operacao_taxa || null,
          quantidade: xCustodiante[xDetalheKey]?.quantidade || 0,
          pu: xCustodiante[xDetalheKey]?.pu || 0,
          financeiro: xCustodiante[xDetalheKey]?.financeiro || 0,
        },
        divergencias: xDivergencias[xDetalheKey] || {},
      };
      xMercados[xMercado].detalhes[xDetalheKey].push(xNewAtivo);
      // Totaliza quantidade e financeiro das possíveis divergências
      xMercados[xMercado].quantidade_total +=
        xNewAtivo.divergencias?.quantidade || 0;
      xMercados[xMercado].financeiro_total +=
        xNewAtivo.divergencias?.financeiro || 0;
    }

    // Ordena os mercados
    const xMercadosSorted = Object.fromEntries(
      Object.entries(xMercados).sort(([a], [b]) => {
        return a.localeCompare(b);
      }),
    );

    return xMercadosSorted;
  }

  useEffect(() => {
    if (!validators.isNull(data.response?.detalhe)) {
      const xDetalhe = data.response.detalhe;
      const xGroupedByMercado = agrupaPorMercado(xDetalhe);
      setSecoes(xGroupedByMercado);
      const xKeys = Object.keys(xGroupedByMercado).sort();
      setValue(xKeys[0]);
    }
  }, [data.response, state.orderBy]);

  if (validators.isNull(data.response) || validators.isNull(value)) {
    return null;
  }

  return (
    <TabContext value={value}>
      <Box>
        <TabList
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="Seções"
        >
          {Object.keys(secoes)
            .sort()
            .map((xKey) => {
              return (
                <Tab
                  key={`tab-${xKey}`}
                  label={
                    xKey === "NIDX"
                      ? "Não Identificados"
                      : ATIVO_MERCADO[xKey].descricao
                  }
                  value={xKey}
                />
              );
            })}
        </TabList>
      </Box>
      {Object.entries(secoes)
        .sort()
        .map(([xKey, xValue]) => {
          return (
            <TabPanel
              value={xKey}
              sx={{ px: 0, pt: 0, marginTop: "0px !important" }}
            >
              <Detalhes detalhe={xValue} />
            </TabPanel>
          );
        })}
    </TabContext>
  );
});

export default Secoes;
